import { APIFeatures } from '../util/apifeatures';
import { StatusCodes } from '../util/statuscodes';
import { ResponseMapper } from '../../utils/httpclient/response/responsemapper';
import { Logger, LogManager } from '../../utils/logger/logger';
import { APIProcessorImpl } from './apiProcessor';
import { Strings } from '../../utils/resources/strings';
import { SettingsRequest } from '../api/settings/settingsrequest';
import { SettingsResponse, SettingsResponseDtoImpl } from '../api/settings/settingsresponse';

export class SettingsAPIProcessorImpl extends APIProcessorImpl<SettingsRequest, SettingsResponse>
{
    private LOGGER: Logger = LogManager.getLogger(SettingsAPIProcessorImpl.name);
     execute(request: SettingsRequest): void
    {
        super.execute(request);

        //  let settingsJsonData = require("./settings.json");
        // console.log("settingsJsonData: ", settingsJsonData.responseMap);

        // let response = new SettingsResponseDtoImpl(APIFeatures.SETTINGS , "Valid Password");
       
        // this.getContext().setConfigurationSettings(JSON.parse(JSON.stringify(settingsJsonData.responseMap.settings)).others);
      
        // this.getAPISuccess(response);

    }
     
     onSuccess(responseMapper: ResponseMapper): void 
    {
        super.onSuccess(responseMapper);
        try{
            this.LOGGER.log("onSuccess() invoked : "+responseMapper.getStatusCode());
            
            if(+responseMapper.getStatusCode() === StatusCodes.SUCCESS)
            {
                let response = new SettingsResponseDtoImpl(APIFeatures.SETTINGS , "Valid Password");

                let responseMap = responseMapper.getResponseMap();
               
                this.getContext().setConfigurationSettings(JSON.parse(JSON.stringify(responseMap.settings)).others);
              
                this.getAPISuccess(response);
            }
            else if(+responseMapper.getStatusCode() === StatusCodes.NO_CONTENT)
            {
                this.getAPISuccess(new SettingsResponseDtoImpl(APIFeatures.SETTINGS, this.getContext().getResources().getString(Strings.internal_server_error)));
            }
            else if(+responseMapper.getStatusCode() === StatusCodes.INTERNAL_SERVER_ERROR)
            {
                this.getAPIFailure(new SettingsResponseDtoImpl(APIFeatures.SETTINGS, this.getContext().getResources().getString(Strings.internal_server_error)));
            }
        }
        catch(e)
        {
            this.getAPIFailure(new SettingsResponseDtoImpl(APIFeatures.SETTINGS, this.getContext().getResources().getString(Strings.internal_server_error)));
        }
    }

    onFailure(responseMapper: ResponseMapper): void 
    {
           
                this.getAPIFailure(new SettingsResponseDtoImpl(APIFeatures.FAILURE, responseMapper.getStatusMsg()));
            
    } 
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/processor/settingsapiprocessor.tsx